/** Settings → AI: what the assistant did (after confirmation), each undoable. */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Undo2 } from 'lucide-react';
import { undoAction, type Undo } from '@nexus/ai';
import { useStore, useStoreQuery } from '../db/context';

export function ActivityLog() {
  const { t, i18n } = useTranslation();
  const store = useStore();
  const log = useStoreQuery((s) => s.listAiActivity(50), [], ['ai']);
  const [failed, setFailed] = useState<Set<string>>(new Set());
  const fmt = new Intl.DateTimeFormat(i18n.language, { dateStyle: 'short', timeStyle: 'short' });

  if (!log) return null;
  if (log.length === 0) return <p className="text-sm text-fg-muted">{t('ai.activity.empty')}</p>;
  return (
    <ul
      className="flex flex-col divide-y divide-border text-sm"
      aria-label={t('ai.activity.title')}
    >
      {log.map((a) => (
        <li key={a.id} className="flex items-center gap-2 py-1.5">
          <span className="w-28 shrink-0 text-xs text-fg-muted">{fmt.format(a.createdAt)}</span>
          <span className={a.undoneAt ? 'flex-1 text-fg-muted line-through' : 'flex-1'}>
            {a.summary}
            {failed.has(a.id) && (
              <span className="block text-xs text-danger">{t('ai.actions.undoFailed')}</span>
            )}
          </span>
          {a.undoneAt ? (
            <span className="text-xs text-fg-muted">{t('ai.actions.status.undone')}</span>
          ) : (
            <button
              type="button"
              onClick={async () => {
                if (await undoAction(store, a.undo as Undo)) await store.markAiActivityUndone(a.id);
                else setFailed((f) => new Set(f).add(a.id));
              }}
              className="flex items-center gap-1 rounded px-1.5 py-0.5 text-xs text-fg-muted hover:bg-bg-hover hover:text-fg"
            >
              <Undo2 className="size-3" />
              {t('ai.actions.undo')}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
